// extracted by mini-css-extract-plugin
module.exports = {"parent":"Management_parent_3bEr-","plan_or_video":"Management_plan_or_video_2lERj","enable":"Management_enable_1pEHe","disable":"Management_disable_SMxwl"};